export default __webpack_public_path__ + "images/c58781fb162fe2eae348f17d78f864cd.svg";